import { unix } from "moment"

const defaults = {
  segment: 5,
}

let previousCurrentTime = -1
let previousPercent = -1

export default (e, options = {}) => {
  options = { ...defaults, ...options }
  if (!window.dataLayer) return
  const dataLayer = window.dataLayer
  const tagName = capitalize(e.target.tagName)
  const src = e.target.currentSrc

  switch (e.type) {
    case "play":
      dataLayer.push({
        event: `Play`,
        event_category: tagName,
        event_label: src,
        non_interaction: true,
        audioPlayerAction: `Play`,
        audioTitle: src,
      })
      break
    case "ended":
      dataLayer.push({
        event: `Ended`,
        event_category: tagName,
        event_label: src,
        non_interaction: true,
        audioPlayerAction: `Ended`,
        audioTitle: src,
      })
      break
    case "timeupdate":
      if (!e.target.duration) return
      const currentTime =
        Math.floor(e.target.currentTime / options.segment) * options.segment
      const percent = Math.floor(
        (e.target.currentTime / e.target.duration) * 10
      ) * 10
      if (percent != previousPercent) {
        dataLayer.push({
          event: `Progress ${percent}%`,
          event_category: tagName,
          event_label: src,
          non_interaction: true,
          audioPlayerAction: `Progress ${percent}%`,
          audioTitle: src,
        })
        previousPercent = percent
      }
      break
  }

  //options = { ...defaults, ...options }
  //if (!window.gtag) return
  //const gtag = window.gtag
  //const tagName = capitalize(e.target.tagName)
  //const src = e.target.currentSrc
  //switch (e.type) {
  //  case "play":
  //    gtag("event", "Play", {
  //      event_category: tagName,
  //      event_label: src,
  //      non_interaction: true,
  //    })
  //    break
  //  case "ended":
  //    gtag("event", "Ended", {
  //      event_category: tagName,
  //      event_label: src,
  //      non_interaction: true,
  //    })
  //    break
  //  case "timeupdate":
  //    const currentTime = Math.floor(e.target.currentTime / options.segment) * options.segment
  //    const percent = Math.floor(e.target.currentTime / e.target.duration * 100)
  //    if (currentTime == previousCurrentTime) break
  //    gtag("event", "TimeUpdate", {
  //      event_category: tagName,
  //      event_label: src,
  //      audioPlayerAction: `Progress ${unix(currentTime).format("mm:ss")}`,
  //      audioProgressPercent: percent,
  //      audioTitle: src,
  //      non_interaction: true,
  //    })
  //    previousCurrentTime = currentTime
  //    break
  //}
}

function capitalize(s) {
  if (typeof s !== "string") return ""
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
}
